module.exports = __webpack_public_path__ + "img/logo_company.e0b0a39b.png";